import HubRedirect from "@/features/hub/HubRedirect";
import { parseCustomerId } from "@/features/hub/customerPath";
import { createFileRoute, notFound, rootRouteId } from "@tanstack/react-router";

export const Route = createFileRoute("/_hub/$customerId/")({
    component: CustomerRedirect,
    beforeLoad: ({ params }) => {
        if (!parseCustomerId(params.customerId)) {
            throw notFound({ routeId: rootRouteId });
        }
    },
    staticData: {
        titleFn: null,
    },
});

function CustomerRedirect() {
    const { customerId } = Route.useParams();
    const parsedCustomerId = parseCustomerId(customerId);

    if (!parsedCustomerId) {
        throw notFound({ routeId: rootRouteId });
    }

    return <HubRedirect customerId={parsedCustomerId} />;
}
